import { useFormikContext } from "formik";
import { useCallback } from "react";
import { FormInputProps } from "src/components/Inputs/FormInput";
import { isUserGeneratedKey } from "src/scenes/orgAdmin/formTemplates/ContentTab/V3/autoGenerateKey";
import * as AF from "src/types/formTemplate";
import { z } from "zod";
import { InputControlWithQuestionId } from "../InputControlWithQuestionId";

interface QuestionKeyProps extends FormInputProps {
  questionId: uuid;
  otherQuestions: readonly AF.V3.Question[];
}

export const FormikSchema = z.object({
  key: z.string().min(1, "This field is required"),
  userGeneratedKey: z.boolean(),
});

export type FormikType = z.infer<typeof FormikSchema>;

export function toFormValue(question: AF.V3.Question): FormikType {
  const userGeneratedKey = isUserGeneratedKey(question.key, question.question);

  return {
    key: question.key,
    userGeneratedKey,
  };
}

export function QuestionKey(props: QuestionKeyProps) {
  const { questionId, otherQuestions, ...formInputProps } = props;

  const formik = useFormikContext<FormikType>();
  const handleChange = useCallback(
    async (value: string) => {
      await formik.setFieldValue("key", value);
      // set userGeneratedKey to true when user type in non empty key manually
      await formik.setFieldValue("userGeneratedKey", value.trim().length > 0);
    },

    [formik]
  );
  return (
    <InputControlWithQuestionId
      name="key"
      inputProps={{
        ...formInputProps,
        onChange: async (event) => {
          const inputElement = event.target as HTMLInputElement;
          const value = inputElement.value;
          handleChange(value);
        },
      }}
      questionId={questionId}
      label="Question key"
    />
  );
}
